<template>
  <div class="" style="">
    <div class="card-box" v-for="item in list">
      <header class="card-name">
        {{item.name}}
      </header>

      <router-link tag="div" :to="{path:child.path,query:{url: child.url}}" v-for="child in item.children" style="text-align:center">
        <card :title="child.name" :cardStyle="{padding: '0px',cursor: 'pointer' }">
           <div class="" slot="media">
              <img src="../../assets/logo.png" style="width: 100%;" alt="" />
           </div>
        </card>
      </router-link>
    </div>
  </div>
</template>

<script>
  // 引入组件
  import card from 'components/card.vue'

  export default {
  data() {
    return {
      currentDate: new Date(),
      list:[],
      title: "ss"
    };
  },
  components:{
    card: card
  },
   methods: {
      request: function(){
         var vm = this
         vm.list = [
            {
              name:'基础档案',
              children:[
                {name:"产品档案",path:'/xdProduct', url:'http://pre.xd.imfbp.com/imfbp-loan-web//xdProduct/toXdProductPage?moduleValue=product&rt=kWS2f8WMmNcw5x65YJMdT4AQMiFT8y3H'},
                {name:"参数设置",path:'/xdParamset', url:'http://pre.xd.imfbp.com/imfbp-loan-web/xdParamset/toXdParamsetPage?moduleValue=paramset&rt=S68s5Q3QrFBzxAKmxFJG35bGkJYTxHB8'}
              ]
            }
         ]

      },
      opentab: function(child){
        var path = child.path;
        this.$router.push({path:path,query:{url: child.url}});
      }
    },

    created: function(){
      this.request()
    }
}
</script>

<style>
  .card-box {
    margin:0 auto;
    background: #fff;
    position: relative;
    z-index: 0;
    overflow: hidden;
  /*  margin-top: 29px!important;*/
    /*border-radius: 8px;*/
    /*border: 1px solid rgba(0,0,0,.14);*/
    /*box-shadow: 0 3px 8px -6px rgba(0,0,0,.1);*/
    box-sizing: border-box;
  }

  .card-name{
    background: #fafafa;
    line-height: 60px;
    font-size: 18px;
    color: #666;
    position: relative;
    display: block;
    padding-left: 30px;
    box-shadow: none;
    border-bottom: 1px solid #eee
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 50%;
    display: block;
    margin: 0 auto;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>
 No newline at end of file



// WEBPACK FOOTER //
// index.vue?177c66e6